export const WEBSITE_BRAND_SUFFIX = '.app';

export function splitWebsiteBrandLabel(label: string) {
  if (!label.toLowerCase().endsWith(WEBSITE_BRAND_SUFFIX)) {
    return { label, suffix: '' };
  }

  return {
    label: label.slice(0, -WEBSITE_BRAND_SUFFIX.length),
    suffix: label.slice(-WEBSITE_BRAND_SUFFIX.length),
  };
}
